import { render, staticRenderFns } from "./antirollback.vue?vue&type=template&id=4a6f1f9a&scoped=true&"
import script from "./antirollback.vue?vue&type=script&lang=js&"
export * from "./antirollback.vue?vue&type=script&lang=js&"
import style0 from "./antirollback.vue?vue&type=style&index=0&id=4a6f1f9a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6f1f9a",
  null
  
)

export default component.exports